import { useQuery } from 'react-query';

import { axios } from 'lib';

const getCellRates = (frameworkAgreementId, lotId, roleId, levelId) => {
  return axios.get(
    `/api/framework_agreements/${frameworkAgreementId}/rates/lots/${lotId}/roles/${roleId}/levels/${levelId}`
  );
};

export const useCellRates = (frameworkAgreementId, lotId, roleId, levelId, options = {}) => {
  return useQuery(
    `framework_agreements-${frameworkAgreementId}-rates-lots-${lotId}-roles-${roleId}-levels-${levelId}`,
    () => getCellRates(frameworkAgreementId, lotId, roleId, levelId),
    {
      //@ts-ignore
      initialData: { data: { data: [] } },
      select: ({ data }) => data.data,
      ...options,
    }
  );
};
